import styled from "styled-components";

const Container = styled.div`
  padding-right: 15px;
  padding-left: 15px;
  margin: 0 auto;
  width: 90%;
  
  @media (min-width: 768px) {
    width: 750px;
  }
  @media (min-width: 992px) {
    width: 970px;
  }
  @media (min-width: 1200px) {
    width: 1170px;
  }
`;

export default Container;



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Container.js